<template>
  <div class="panel panel-default">
    <div class="panel-heading">{{ caixaAlta(limitar(paciente.nome, 30)) }}</div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr>
            <td><strong>Nome Social</strong></td>
            <td>{{ limitar(paciente.nome_social, 30) }}</td>
          </tr>
          <tr>
            <td><strong>Nascimento</strong></td>
            <td>{{ formatarData(paciente.data_nascimento, 'DD/MM/YYYY') }}</td>
          </tr>
          <tr>
            <td><strong>CPF</strong></td>
            <td v-if="paciente.docs_pessoais">{{
              formatarCpf(paciente.docs_pessoais.cpf)
            }}</td>
          </tr>
          <tr>
            <td><strong>Situação</strong></td>
            <td :class="paciente.ativo ? 'text-success' : 'text-danger'">{{
              paciente.ativo ? 'Ativo' : 'Cancelado'
            }}</td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          data-test-id="link-auto-1"
          :to="'/paciente/cadastro/' + paciente._id"
          role="button"
          class="btn btn-sm btn-default"
          ><span class="fa fa-edit" /> Editar</RouterLink
        >
        <RouterLink
          data-test-id="link-auto-2"
          :to="'/paciente/' + paciente._id + '/agendamentos'"
          role="button"
          class="btn btn-sm btn-default"
          ><span class="fa fa-calendar" /> Agendamentos</RouterLink
        >
        <RouterLink
          v-if="verificaAcao('evolucao_paciente')"
          data-test-id="link-auto-3"
          :to="'/paciente/' + paciente._id + '/evolucao2'"
          role="button"
          class="btn btn-sm btn-default"
          ><span class="fa fa-clipboard" /> Evolução</RouterLink
        >
      </div>
    </div>
  </div>
</template>

<script>
import ControleAcessoServico from '@/servicos/ControleAcessoServico'
import * as formatadores from '@/utils/formatadores'

const controleAcessoServico = new ControleAcessoServico()

export default {
  name: 'PacienteFicha',
  props: {
    paciente: {
      type: Object,
      required: true,
      validator: (value) => {
        return value && value._id
      },
    },
  },
  methods: {
    ...formatadores,
    verificaAcao(nome) {
      return controleAcessoServico.verificaAcao(nome)
    },
  },
}
</script>
